























import Vue from 'vue'

type Props = {
  value?: boolean | string // 入力値
  inputValue?: boolean | string[] // v-model のバインド値
  rules?: string | Record<string, boolean>
  trueValue?: boolean
  falseValue?: boolean
}

type Computed = {
  isChecked: boolean
  localValue: boolean
}

type Methods = {
  onChange: (checked: boolean) => void
}

/**
 * @see https://jp.vuejs.org/v2/api/#model
 */
export default Vue.extend<{}, Methods, Computed, Props>({
  inheritAttrs: false,
  name: 'XCheckbox',
  model: {
    prop: 'inputValue',
    event: 'input',
  },
  props: {
    value: {
      type: [String, Boolean],
      default: false,
    },
    inputValue: {
      type: [Array, Boolean],
      default: false,
    },
    rules: {
      type: [String, Object],
    },
    trueValue: {
      default: true,
    },
    falseValue: {
      default: false,
    },
  },
  computed: {
    isChecked() {
      if (this.inputValue instanceof Array) {
        return this.inputValue.includes(this.value as string)
      } else {
        return this.inputValue === this.trueValue
      }
    },
    localValue: {
      get() {
        return this.isChecked
      },
      set(v) {
        this.onChange(v)
      },
    },
  },
  methods: {
    onChange(checked: boolean) {
      if (this.inputValue instanceof Array) {
        const input = [...this.inputValue]

        checked
          ? input.push(this.value as string)
          : input.splice(input.indexOf(this.value as string), 1)

        this.$emit('input', input)
      } else {
        this.$emit('input', checked ? this.trueValue : this.falseValue)
      }
    },
  },
})
